var map = {
	"./views/base/base.module": [
		"./src/app/views/base/base.module.ts",
		"views-base-base-module"
	],
	"./views/buttons/buttons.module": [
		"./src/app/views/buttons/buttons.module.ts",
		"views-buttons-buttons-module"
	],
	"./views/chartjs/chartjs.module": [
		"./src/app/views/chartjs/chartjs.module.ts",
		"views-chartjs-chartjs-module"
	],
	"./views/dashboard/dashboard.module": [
		"./src/app/views/dashboard/dashboard.module.ts",
		"default~views-dashboard-dashboard-module~views-theme-theme-module~views-widgets-widgets-module",
		"common",
		"views-dashboard-dashboard-module"
	],
	"./views/icons/icons.module": [
		"./src/app/views/icons/icons.module.ts",
		"views-icons-icons-module"
	],
	"./views/notifications/notifications.module": [
		"./src/app/views/notifications/notifications.module.ts",
		"views-notifications-notifications-module"
	],
	"./views/theme/theme.module": [
		"./src/app/views/theme/theme.module.ts",
		"default~views-dashboard-dashboard-module~views-theme-theme-module~views-widgets-widgets-module",
		"common",
		"views-theme-theme-module"
	],
	"./views/widgets/widgets.module": [
		"./src/app/views/widgets/widgets.module.ts",
		"default~views-dashboard-dashboard-module~views-theme-theme-module~views-widgets-widgets-module",
		"common",
		"views-widgets-widgets-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;